import { render, staticRenderFns } from "./OtherInvestigationLabRequest.vue?vue&type=template&id=3b8f059c&"
import script from "./OtherInvestigationLabRequest.vue?vue&type=script&lang=js&"
export * from "./OtherInvestigationLabRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports